"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),i=require("react/jsx-runtime"),a=require("styled-components"),t=require("@vds-tokens/core"),o=require("@vds/buttons"),n=require("@vds/typography"),s=require("@plans/badges"),l=require("@vds/lists"),r=require("@plans/utilities"),d=require("@plans/type-lockups"),p=require("@vds/icons"),c=require("../tile/index.js");function u(e){return e&&e.__esModule?e:{default:e}}var m=u(a);const g=m.default(c.default).withConfig({displayName:"StyledTile",componentId:"VDS__sc-13b7u3-0"})`
  > div > div {
    > div:last-of-type {
      flex-direction: column;
      pointer-events: auto;
    }
  }
`,b=m.default.div.withConfig({displayName:"CapDesktopWrapper",componentId:"VDS__sc-13b7u3-1"})`
  @media (max-width: ${r.breakpoints.mobileLarge.max}) {
    display: none;
  }
`,h=m.default.div.withConfig({displayName:"CapMobileWrapper",componentId:"VDS__sc-13b7u3-2"})`
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    display: none;
  }
`,x=m.default.div.withConfig({displayName:"InnerTileWrapper",componentId:"VDS__sc-13b7u3-3"})`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${({padding:e})=>e||t.LayoutTokens.space["4X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    padding: ${({padding:e})=>e||t.LayoutTokens.space["6X"].value};
  }
  pointer-events: auto;
  width: 100%;
`,f=m.default.div.withConfig({displayName:"HeaderOuterWrapper",componentId:"VDS__sc-13b7u3-4"})`
  display: flex;
  flex-direction: column;
  padding-bottom: ${t.LayoutTokens.space["8X"].value};
  width: 100%;
`,y=m.default.div.withConfig({displayName:"HeaderInnerWrapper",componentId:"VDS__sc-13b7u3-5"})`
  display: flex;
  flex-direction: column;
  width: 100%;
`,v=a.css`
  max-width: 100%;
  padding-bottom: ${t.LayoutTokens.space["2X"].value};
  > * {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
  }
`,j=m.default.span.withConfig({displayName:"TitleWrapper",componentId:"VDS__sc-13b7u3-6"})`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({maxLines:e})=>e||2};
  display: -webkit-box;
  overflow: hidden; ;
`,k=m.default.div.withConfig({displayName:"FocusedTitleWrapper",componentId:"VDS__sc-13b7u3-7"})`
  ${v};
  position: relative;
  span:nth-of-type(1) {
    display: block;
    margin-bottom: 4px;
    max-width: ${({maxWidth:e})=>e||"50%"};
  }
`,w=m.default.span.withConfig({displayName:"FocusedSubtitleWrapper",componentId:"VDS__sc-13b7u3-8"})`
  display: flex;
  height: 60px; // Reserve height so lists start at same spot in group
  width: 100%;
`,_=m.default.div.withConfig({displayName:"HeaderImageWrapper",componentId:"VDS__sc-13b7u3-9"})`
  position: absolute;
  right: 0;
  top: 0;
`,C=m.default.img.withConfig({displayName:"StyledImage",componentId:"VDS__sc-13b7u3-10"})`
  align-items: center;
  display: flex;
  height: 28px;
  justify-content: center;
  object-fit: contain;
  width: auto;
`,T=m.default.span.withConfig({displayName:"IconListWrapper",componentId:"VDS__sc-13b7u3-11"})`
  display: flex;
  flex-direction: column;
`,S=m.default.div.withConfig({displayName:"Footer",componentId:"VDS__sc-13b7u3-12"})`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: auto;
`,I=m.default.div.withConfig({displayName:"FooterOuterWrapper",componentId:"VDS__sc-13b7u3-13"})`
  display: flex;
  flex-direction: column;
  gap: ${t.LayoutTokens.space["1X"].value};
  margin-bottom: ${t.LayoutTokens.space["6X"].value};
`,L=m.default.div.withConfig({displayName:"FooterBadgeWrapper",componentId:"VDS__sc-13b7u3-14"})`
  ${({$preserveFooterBadgeHeight:e})=>e&&"height: 20px"};
`,$=m.default.div.withConfig({displayName:"FooterInnerWrapper",componentId:"VDS__sc-13b7u3-15"})`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`,D=m.default.div.withConfig({displayName:"FooterPriceWrapper",componentId:"VDS__sc-13b7u3-16"})`
  display: flex;
  flex-direction: column;
  gap: ${t.LayoutTokens.space["1X"].value};
`,O=m.default.div.withConfig({displayName:"PriceInnerWrapper",componentId:"VDS__sc-13b7u3-17"})`
  display: flex;
  flex-direction: row;
  gap: ${t.LayoutTokens.space["1X"].value};
`,N=m.default.div.withConfig({displayName:"PriceDesktopWrapper",componentId:"VDS__sc-13b7u3-18"})`
  @media (max-width: ${r.breakpoints.mobileLarge.max}) {
    display: none;
  }
`,V=m.default.div.withConfig({displayName:"PriceMobileWrapper",componentId:"VDS__sc-13b7u3-19"})`
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    display: none;
  }
`,W=m.default.span.withConfig({displayName:"ScreenReaderText",componentId:"VDS__sc-13b7u3-20"})`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`,X=m.default.div.withConfig({displayName:"PriceTermWrapper",componentId:"VDS__sc-13b7u3-21"})`
  display: flex;
  flex-direction: column;
  justify-content: end;
`,F=m.default.span.withConfig({displayName:"SubtileWrapper",componentId:"VDS__sc-13b7u3-22"})`
  display: flex;
  flex-direction: column;
  gap: ${t.LayoutTokens.space["3X"].value};
  padding-top: ${t.LayoutTokens.space["4X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    padding-top: ${t.LayoutTokens.space["6X"].value};
  }
`,z=m.default.span.withConfig({displayName:"SubtileInnerWrapper",componentId:"VDS__sc-13b7u3-23"})`
  display: flex;
  flex-direction: column;
  gap: ${t.LayoutTokens.space["4X"].value};
  > ul > li {
    gap: ${t.LayoutTokens.space["2X"].value};
  }
`,B=m.default.div.withConfig({displayName:"FooterSingleButton",componentId:"VDS__sc-13b7u3-24"})`
  align-items: end;
  display: flex;
  flex-direction: column;
  gap: ${t.LayoutTokens.space["2X"].value};
  justify-content: flex-end;
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    gap: ${t.LayoutTokens.space["3X"].value};
  }
`,q=m.default.div.withConfig({displayName:"FooterIconLabelWrapper",componentId:"VDS__sc-13b7u3-25"})`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${t.LayoutTokens.space["1X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    gap: ${t.LayoutTokens.space["2X"].value};
  }
`,R=m.default.span.withConfig({displayName:"FooterTextLinkWrapper",componentId:"VDS__sc-13b7u3-26"})`
  display: inline-block;
  max-width: fit-content;
  padding-bottom: ${t.LayoutTokens.space["8X"].value};
  padding-top: ${t.LayoutTokens.space["4X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    padding-bottom: ${t.LayoutTokens.space["12X"].value};
    padding-top: ${t.LayoutTokens.space["6X"].value};
  }
  width: 100%;
`,H=m.default.div.withConfig({displayName:"FooterButtonGroupWrapper",componentId:"VDS__sc-13b7u3-27"})`
  height: 20px; // Reserve height of text link at footer when in group or carousel
`;exports.default=a=>{const{backgroundColor:r="stone",banner:u,borderRadius:m,surface:v,id:P,backgroundImage:M,showDropShadow:G,tabIndex:A,eyebrow:Q,title:Y,padding:E,image:J,subtitle:K,list:U,textLink:Z,buttonGroup:ee,price:ie,label:ae,button:te,subtile:oe,viewport:ne,footerBadge:se,preserveFooterBadgeHeight:le}=a,re=e.__rest(a,["backgroundColor","banner","borderRadius","surface","id","backgroundImage","showDropShadow","tabIndex","eyebrow","title","padding","image","subtitle","list","textLink","buttonGroup","price","label","button","subtile","viewport","footerBadge","preserveFooterBadgeHeight"]),de="mobile"===ne||"mobileLarge"===ne,pe=r===t.ColorTokens.background.primary.dark.value?"dark":"light",ce=()=>(null==ie?void 0:ie.color)?ie.color:"dark"===pe?t.ColorTokens.palette.white.value:t.ColorTokens.palette.black.value;return i.jsxs(g,Object.assign({width:"100%",height:"auto",id:P,backgroundColor:r,backgroundImage:M,showDropShadow:G,borderRadius:m,tabIndex:A},re,{onClick:void 0,padding:"0px"},{children:[(()=>{const e=u;return e&&"base"!==e.variant?i.jsxs(i.Fragment,{children:[i.jsx(b,{children:i.jsx(s.Cap,Object.assign({fillColor:"stone"===r?"stone":"red",padding:t.LayoutTokens.space["4X"].value,surface:pe},e,{borderRadius:m}))}),i.jsx(h,{children:i.jsx(s.Cap,Object.assign({fillColor:"stone"===r?"stone":"red",surface:pe,padding:t.LayoutTokens.space["3X"].value},e,{borderRadius:m}))})]}):null})(),i.jsxs(x,Object.assign({padding:E},{children:[i.jsxs(f,{children:[i.jsx(y,{children:Y&&i.jsxs(k,Object.assign({maxWidth:null==Q?void 0:Q.maxWidth},{children:[i.jsxs(n.Title,Object.assign({size:"XLarge",color:"dark"===pe?t.ColorTokens.palette.white.value:t.ColorTokens.palette.red.value,bold:!0},Y,{children:[i.jsx(n.Title,Object.assign({size:"small",color:"dark"===pe?t.ColorTokens.palette.white.value:t.ColorTokens.palette.red.value,bold:!0},Q,{primitive:"span"})),i.jsx(j,Object.assign({maxLines:Y.maxLines},{children:Y.children}))]})),J&&i.jsx(_,{children:i.jsx(C,Object.assign({},J))})]}))}),K&&i.jsx(w,{children:i.jsx(n.Body,Object.assign({size:"large",color:t.ColorTokens.palette.warmgray41.value},K))})]}),U&&(()=>{const e=null==U?void 0:U.map((e=>e.icon?Object.assign(Object.assign({},e),{size:de?"medium":"large",icon:Object.assign({color:"dark"===pe?t.ColorTokens.palette.white.value:t.ColorTokens.palette.red.value},e.icon)}):e));return i.jsx(T,{children:i.jsx(l.IconList,{surface:pe,spacing:"standard",data:e})})})(),i.jsxs(S,{children:[oe&&i.jsx(F,{children:i.jsx(c.default,Object.assign({showDropShadow:!1,backgroundColor:t.ColorTokens.background.primary.light.value,padding:"16px",borderRadius:"16px",height:"auto",role:"presentation"},{children:i.jsxs(z,{children:[oe.savingsText&&i.jsx(n.Body,Object.assign({alignment:"left",color:"stone"===r?t.ColorTokens.palette.warmgray41.value:t.ColorTokens.elements.secondary[`on${pe}`].value,size:de?"medium":"large"},oe.savingsText)),(null==oe?void 0:oe.list)&&(()=>{var e;const a=null===(e=null==oe?void 0:oe.list)||void 0===e?void 0:e.map((e=>e.icon?Object.assign(Object.assign({},e),{size:de?"medium":"large",icon:Object.assign({},e.icon)}):e));return i.jsx(l.IconList,{spacing:"standard",data:a})})()]})}))}),Z&&i.jsx(R,{children:i.jsx(o.TextLink,Object.assign({surface:pe,type:"standAlone",size:"small"},Z))}),(ie||se)&&i.jsxs(I,{children:[ie&&i.jsxs($,{children:[i.jsxs(D,{children:[i.jsxs(O,{children:[i.jsx(N,{children:i.jsxs(n.Title,Object.assign({size:"XLarge",bold:ie.bold,primitive:"span",color:ce()},{children:[ie.hideCurrency?"":"$",ie.price]}))}),i.jsx(V,{children:i.jsxs(n.Title,Object.assign({size:"2XLarge",bold:ie.bold,primitive:"span",color:ce()},{children:[ie.hideCurrency?"":"$",ie.price]}))}),ie.term&&i.jsxs(X,{children:["none"!==ie.term&&i.jsx(n.Body,Object.assign({size:"small",primitive:"span",bold:ie.bold,color:ce()},{children:i.jsxs("span",{children:[i.jsxs("span",{children:[i.jsxs(W,{children:["per ",ie.term]}),i.jsxs("span",Object.assign({"aria-hidden":!0},{children:["/",(()=>{switch(null==ie?void 0:ie.term){case"year":return"yr";case"biennial":return"biennial";default:return"mo"}})()]}))]}),ie.superscript&&i.jsx(n.Super,{children:ie.superscript})]})})),ie.trailingText&&i.jsxs(i.Fragment,{children:[ie.trailingText.ariaLabel&&i.jsx(W,{children:ie.trailingText.ariaLabel}),i.jsx(n.Micro,Object.assign({color:"dark"===pe?t.ColorTokens.palette.gray65.value:t.ColorTokens.palette.warmgray41.value,"aria-hidden":!!ie.trailingText.ariaLabel,bold:ie.bold},null==ie?void 0:ie.trailingText))]})]})]}),ie.sublockups&&Array.isArray(ie.sublockups)&&ie.sublockups.map((e=>i.jsx(d.Pricing,Object.assign({theme:"monarch",size:"3XSmall",color:"secondary",surface:pe},e))))]}),(te||ae)&&i.jsxs(B,{children:[ae&&ae.children&&i.jsxs(q,{children:[ae.icon&&i.jsx(p.Icon,Object.assign({ariaHidden:!0,size:"large",name:"checkmark-alt"},ae.icon)),i.jsx(n.Body,Object.assign({bold:!0,size:"large"},ae))]}),te&&i.jsx(o.Button,Object.assign({size:"large",width:"auto",surface:pe},te))]})]}),(se||le)&&i.jsx(L,Object.assign({$preserveFooterBadgeHeight:le},{children:se&&i.jsx(s.Modified,Object.assign({fillColor:"neonYellow",icon:{name:"lock-closed"}},se))}))]}),i.jsx(H,{children:ee&&i.jsx(o.ButtonGroup,Object.assign({alignment:"center",rowQuantity:{desktop:1,mobile:1,tablet:1},childWidth:"100%",surface:pe},ee))})]})]}))]}))};
